import { FormControl, TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { text } from '~/modules/@shared/helpers/text';
import { CreateInvoiceForm } from '../../helpers/createInvoiceSchema';

export default function InvoiceNotesField() {
  const {
    control,
    formState: { errors },
  } = useFormContext<CreateInvoiceForm>();

  return (
    <Controller
      control={control}
      name="notes"
      render={({ field: { value, ...field } }) => (
        <FormControl fullWidth>
          <TextField
            {...field}
            value={value ?? ''}
            multiline
            rows={6}
            InputProps={{
              inputProps: {
                maxLength: 250,
              },
            }}
            error={!!errors.notes}
            helperText={text(errors.notes?.message)}
            FormHelperTextProps={{ error: true }}
          />
        </FormControl>
      )}
    />
  );
}
